import React, { useState, useEffect, useMemo } from "react";
import MinDataService from "../services/MinService";
import { useSelector } from 'react-redux';
import BeautifulTable from "../../components/BeautifulTable";
import { fNumber } from "../../utils/formatNumber";

const MinUser = (props) => {
  const [min, setMin] = useState([]);

  const { user: currentUser } = useSelector((state) => state.auth);
  const currentUserId = currentUser?.id;

  useEffect(() => {
    retrieveMin();
  }, []); // eslint-disable-line

  const retrieveMin = () => {
    MinDataService.getAll(currentUserId)
      .then((response) => setMin(response.data ?? response))
      .catch((e) => console.log(e));
  };

  const columns = useMemo(
    () => [
      { Header: "Date", accessor: "date", Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : "") },
      { Header: "Amount", accessor: "amount", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Transaction type", accessor: "creditOrDebit" },
      { Header: "Description", accessor: "description" },
      { Header: "New Balance", accessor: "newBalance", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Posted Date", accessor: "createdAt", Cell: ({ value }) => (value ? new Date(value).toLocaleString() : "") }
    ],
    []
  );

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <BeautifulTable
          columns={columns}
          data={min}
          pageSize={10}
          onRowClick={(row) => props.history?.push && props.history.push(`/dashboard/min/${row.id || row._id}`)}
        />
      </div>
    </div>
  );
};

export default MinUser;
